import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import {Colors} from 'advenio-components'
import {path} from 'ramda'
import {ProfileIcon} from "../../ProfilePanel/ProfilePanel.styles";

const Wrapper = styled.div`
  display: flex;
  padding: 8px;
  background-color: ${Colors.advenioRed};
  border-top: 1px solid ${Colors.white300a};
`
const ProfilePicture = styled.div`
  flex: 1 0 auto;
  height: 64px;
  width: 64px;
  border-radius: 4px;
  background-color: ${Colors.red600};
  background-image: ${({profile}) => profile ? `url(${profile})` : ''};
  background-size: cover;
  background-position: center;
`
const ProfileInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`
const Name = styled.h2`
  margin: 0;
  font-weight: 400;
  color: ${Colors.white300};
`
const CloudIcon = styled.img`
  width: 13px;
  margin: 0 4px;
`
const PillsRow = styled.div`
  display: flex;
`
const Pill = styled.div`
  margin: 4px;
  padding: 2px 8px;
  background-color: rgba(255, 255, 255, .25);
  color: ${Colors.white300};
  font-size: 14px;
  border-radius: 10px;

  @media (max-width: 763px) {
    margin-left: 0;
    font-size: 10px;
  }
`
const Icon = styled.div`
  margin-top: 40px;
  background-color: #ffffff;
  border-radius: 12px;
  height: 19px;
  width: 24px;
  padding-bottom: 5px;
  float: right;
`

const ProfilePanel = ({student, onDrop}) => (
  <Wrapper>
    <ProfilePicture
      profile={student.profile_pictures ?
        student.profile_pictures['original'] :
        '/assets/BabyAvatar.svg'
      }
      onClick={() => {
        var [input] = document.getElementsByName('profile');
        input.click();
      }}
    >
      <Icon>
        <img src="/assets/camara.svg" alt="upload camera" style={{width: 27, marginTop: -1, marginLeft: -1}}/>
      </Icon>
    </ProfilePicture>
    <input type="file" name='profile' style={{display: "none", width: 33, marginTop: -4, marginLeft: -3}}
           accept="image/*" onChange={onDrop}/>
    {/*<div
      onClick={() => {
        var [input] = document.getElementsByName('profile');
        input.click();
      }}>
      <ProfilePicture profile={student.profile_pictures ?
        student.profile_pictures['original'] :
        '/assets/BabyAvatar.svg'
      }
      />
      <ProfileIcon style={{marginTop: -36, marginLeft: 55, height: 20, width: 26}}>
        <img src="/assets/camara.svg" alt="upload camera" style={{width: 27, marginTop: -1, marginLeft: -1}}/>
      </ProfileIcon>
      <input type="file" name='profile' style={{display: "none", width: 33, marginTop: -4, marginLeft: -3}}
             accept="image/*" onChange={onDrop}/>
    </div>*/}
    <ProfileInfoContainer>
      <Name>
        {`${student.first_name} ${student.last_name_paternal} ${student.last_name_maternal && student.last_name_maternal}`}
      </Name>
      <PillsRow>
        <Pill>{student.classroom}</Pill>
        <Pill>{student.study_program}</Pill>
        {path(['checkin', 'is_virtual_center'], student) && (
          <Pill>
            <CloudIcon src="/assets/cloud_blue.svg"/>
            {student.center}
          </Pill>
        )}
      </PillsRow>
    </ProfileInfoContainer>
  </Wrapper>
)

ProfilePanel.propTypes = {
  /** The active student */
  student: PropTypes.object.isRequired,
}

export default ProfilePanel



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/ProfilePanel/index.jsx